const workplanWillStart = 'workplanWillStart';
const workplanHasStarted = 'workplanHasStarted';
const workplanPaused = 'workplanPaused';
const workplanStopped = 'workplanStopped';
const shiftlineWillStart = 'shiftlineWillStart';
const shiftlineHasStarted = 'shiftlineHasStarted';
const shiftlinePaused = 'shiftlinePaused';
const shiftlineStopped = 'shiftlineStopped';
const ownerAdded = 'ownerAdded';
const ownerPaused = 'ownerPaused';
const ownerStopped = 'ownerStopped';
const reliefAdded = 'reliefAdded';
const reliefRemoved = 'reliefRemoved';
const reliefModified = 'reliefModified';
const workplanWillStop = 'workplanWillStop';

export const WorkflowNotifications = Object.freeze({
    [workplanWillStart]: 0,
    [workplanHasStarted]: 1,
    [workplanPaused]: 2,
    [workplanStopped]: 3,
    [shiftlineWillStart]: 4,
    [shiftlineHasStarted]: 5,
    [shiftlinePaused]: 6,
    [shiftlineStopped]: 7,
    [ownerAdded]: 8,
    [ownerPaused]: 9,
    [ownerStopped]: 10,
    [reliefAdded]: 11,
    [reliefRemoved]: 12,
    [reliefModified]: 13,
    [workplanWillStop]: 14,
});

export const WorkflowNotificationsKeys = Object.freeze({
    0: workplanWillStart,
    1: workplanHasStarted,
    2: workplanPaused,
    3: workplanStopped,
    4: shiftlineWillStart,
    5: shiftlineHasStarted,
    6: shiftlinePaused,
    7: shiftlineStopped,
    8: ownerAdded,
    9: ownerPaused,
    10: ownerStopped,
    11: reliefAdded,
    12: reliefRemoved,
    13: reliefModified,
    14: workplanWillStop,
});
